import React, { useEffect, useMemo, useState } from 'react';
import {
  Card, Form, Row, Col,
} from 'react-bootstrap';

import Required from '../../Required';
import ResultCard from '../Partials/ResultCard';
import Select from 'react-select';
import useAPI from '../../../hooks/useAPI';
import { Tooltip } from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

const default_labelsCfg = {
  cardHeader: 'Результаты проекта',
  resultLabel: 'Описание итогового результата проекта',
  resultPlaceholder: 'Описание итогового результата проекта в соответствии с информацией в Программе развития',
  productDescrLabel: 'Описание продукта проекта',
  productDescrPlaceholder: 'Краткое описание продукта, созданного по итогу реализации проекта',
  consumersLabel: 'Потребители результатов проекта (продуктов)',
  consumersPlaceholder: 'Необходимо указать внутренние подразделения университета либо категории сотрудников, которые будут применять результаты проекта. Необходимо отдельно выделить главного потребителя, т.е. подразделение на результатах которого главным образом скажется проект.',
};

export default function Results({
  data, periods, onChange, letters, resultTypes, labelsCfg, disabled
}) {
  const labels = useMemo(() => ({ ...default_labelsCfg, ...(labelsCfg || {}) }), [labelsCfg]);

  return (
    <Card className="mb-4">
      <Card.Header as={Card.Title} className="p-4">{labels.cardHeader}</Card.Header>
      <Card.Body className="p-4">
        <Row className="mb-4">
          <Form.Group as={Col}>
            <Form.Label>
              {labels.resultLabel}
              {' '}
              <Required />
              {' '}
              <Tooltip
                placement="top"
                title={<p style={{ fontSize: 12 }}>{labels.resultPlaceholder}</p>}
                interactive
              >
                <HelpOutlineIcon style={{ opacity: '0.66'}} fontSize="inherit" />
              </Tooltip>
            </Form.Label>
            <Form.Control
              placeholder={labels.resultPlaceholder}
              required
              as="textarea"
              rows={3}
              value={data.result}
              onChange={(elem) => onChange(elem.target.value, 'result')}
              disabled={disabled}
            />
            <Form.Control.Feedback type="invalid">Обязательное поле к заполнению</Form.Control.Feedback>
          </Form.Group>
        </Row>
        <Row className="mb-4">
          <Form.Group as={Col}>
            <Form.Label>
              {labels.productDescrLabel}
              {' '}
              <Required />
              {' '}
              <Tooltip
                placement="top"
                title={<p style={{ fontSize: 12 }}>{labels.productDescrPlaceholder}</p>}
                interactive
              >
                <HelpOutlineIcon style={{ opacity: '0.66'}} fontSize="inherit" />
              </Tooltip>
            </Form.Label>
            <Form.Control
              placeholder={labels.productDescrPlaceholder}
              required
              as="textarea"
              rows={3}
              value={data.productDescr}
              onChange={(elem) => onChange(elem.target.value, 'productDescr')}
              disabled={disabled}
            />
            <Form.Control.Feedback type="invalid">Обязательное поле к заполнению</Form.Control.Feedback>
          </Form.Group>
        </Row>
        <Row className="mb-4">
          <h5>В том числе</h5>
        </Row>
        <ResultCard
          data={data.results}
          periods={periods}
          resultTypes={resultTypes}
          required={!!data.strategyId}
          onChange={(results) => onChange(results, 'results')}
          letters={letters}
          disabled={disabled}
        />
        <Row className="mb-4">
          <Form.Group as={Col}>
            <Form.Label>
              {labels.consumersLabel}
              {' '}
              <Required />
            </Form.Label>
            <Form.Control
              placeholder={labels.consumersPlaceholder}
              required
              as="textarea"
              rows={3}
              value={data.consumers}
              onChange={(elem) => onChange(elem.target.value, 'consumers')}
              disabled={disabled}
            />
            <Form.Control.Feedback type="invalid">Обязательное поле к заполнению</Form.Control.Feedback>
          </Form.Group>
        </Row>
      </Card.Body>
    </Card>
  );
}

const cardHeaderStyling = {
  display: 'flex', justifyContent: 'end',
};
